import { useEffect, useState } from "react";

import { useToast } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { ERROR_MESSAGES } from "../constants/error_messages";
import { AuthService } from "../services/auth.service";

const authService = new AuthService();

export const useResetPassword = () => {
  const { token } = useParams();

  const toast = useToast();

  const [mode, setMode] = useState<"request" | "change">();

  const [email, setEmail] = useState<string>("");
  const [emailSent, setEmailSent] = useState<boolean>(false);

  const [password, setPassword] = useState<string>("");
  const [password2, setPassword2] = useState<string>("");

  const [valid, setValid] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMsgs, setErrorMsgs] = useState<string[]>([]);

  useEffect(() => {
    if (token) {
      setMode("change");
    } else {
      setMode("request");
    }
  }, [token]);

  useEffect(() => {
    setErrorMsgs([]);
  }, []);

  useEffect(() => {
    validateData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, password, password2]);

  const validateData = () => {
    setValid(true);
    setErrorMsgs([]);
    let newErrorMsgs: string[] = [];

    if (mode === "request") {
      if (email === "" || !email) {
        newErrorMsgs.push("Introce tu correo electrónico");
        setValid(false);
      }

      if (!email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        newErrorMsgs.push("Introduce un correo electrónico válido");
        setValid(false);
      }
    } else if (mode === "change") {
      if (password === "" || !password) {
        setValid(false);
        newErrorMsgs.push("Introce una contraseña");
      }
      if (password !== password2) {
        newErrorMsgs.push("Las contraseñas no coinciden");
        setValid(false);
      }
      if (
        password.length < 8 ||
        !password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)
      ) {
        newErrorMsgs.push(
          "La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número"
        );
        setValid(false);
      }
    }

    setErrorMsgs(newErrorMsgs);
  };

  const requestResetPassword = (email: string) => {
    setLoading(true);

    authService
      .requestResetPassword(email)
      .then(({ data }) => {
        console.log("data", data);

        setErrorMsgs([]);
        setEmailSent(true);

        toast({
          title: "Correo enviado",
          description: "Revisa tu correo para cambiar tu contraseña",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch((err) => {
        console.error(err);
        setErrorMsgs([
          ERROR_MESSAGES[err.response.data.code] || err.response.data.code,
        ]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePwdReset = (token: string, password: string) => {
    setLoading(true);

    authService
      .resetPassword({
        token,
        password,
      })
      .then(({ data }) => {
        console.log("data", data);
        toast({
          title: "Contraseña cambiada",
          description: "Tu contraseña ha sido cambiada correctamente",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        localStorage.setItem("jwt", data.session.user.id);
        window.dispatchEvent(new Event("storage"));
      })
      .catch((err) => {
        console.error(err);
        setErrorMsgs([
          ERROR_MESSAGES[err.response.data.code] || err.response.data.code,
        ]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    token,
    mode,
    email,
    setEmail,
    password,
    setPassword,
    password2,
    setPassword2,
    emailSent,
    loading,
    valid,
    errorMsgs,
    requestResetPassword,
    handlePwdReset,
  };
};
